/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Button,
    Switch,
    LinearProgress,
    Stack,
    Typography,
    Chip,
    IconButton,
    TextField,
    Select,
    FormControl,
    MenuItem,
    FormControlLabel,
    Radio,
    RadioGroup,
    Checkbox,
    Grid,
    Tabs,
    Tab,
    OutlinedInput,
    ListItemText,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from '@mui/icons-material/Add';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import "./AICampaignBuilder.scss";


const AiCampaignBuilder = () => {
    const navigate = useNavigate();

    // Campaign Settings States
    const [campaignName, setCampaignName] = useState("");
    const [campaignBudget, setCampaignBudget] = useState("AED 40,000");
    const [campaignFor, setCampaignFor] = useState("");
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [selectedVendors, setSelectedVendors] = useState<string[]>([]);
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
    const [marketingFunding, setMarketingFunding] = useState("");
    const [duration, setDuration] = useState("All Users");
    const [newReturningUsers, setNewReturningUsers] = useState(true);
    const [salesChannel, setSalesChannel] = useState(true);
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const [activeTab, setActiveTab] = useState(0);

    // Sample data
    const categories = ["Clothing", "Electronics", "Home", "Beauty", "Toys"];
    const vendorList = ["Vendor A", "Vendor B", "Vendor C", "Vendor D"];
    const segments = ["VIP Customers", "First Time Buyers", "Inactive Users"];
    const subscriptions = ["Premium", "Standard", "Basic"];
    const products = ["Select All","T-Shirt", "Laptop", "Sofa", "Lipstick", "Drone", "Headphones", "Watch", "Shoes"];

    // Handle Save
    const handleSave = () => {
        const payload = {
            campaignName,
            campaignFor,
            selectedItems,
            selectedVendors,
            selectedProducts,
            marketingFunding,
            startDate,
            endDate,
            duration,
        };
        console.log("Campaign Data:", payload);
    };

    // Sample campaign data
    const campaigns = [
        {
            id: 1,
            name: "Diwali Mega Sale",
            type: "Discount",
            discountType: "Percentage",
            discountValue: "15%",
            startDate: "20 Nov 2025",
            endDate: "30 Nov 2025",
            minPurchase: "₹500",
            usageLimit: "100",
            createdDate: "10 Nov 2025",
            status: true,
        },
        {
            id: 2,
            name: "Free Shipping Weekend",
            type: "Free Shipping",
            discountType: "-",
            discountValue: "-",
            startDate: "15 Dec 2025",
            endDate: "17 Dec 2025",
            minPurchase: "-",
            usageLimit: "Unlimited",
            createdDate: "05 Dec 2025",
            status: false,
        },
    ];

    return (
        <>
            <div className="main_title">
                <h1>AI Campaign Builder</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - AI Campaign Builder
                </p>
            </div>
            <div className="table_flex">
                <div className="lt">
                    <div className="campaign_goal_section">
                        <h3 className="section_title">Campaign Goal</h3>

                        <div className="goal_cards">
                            <div className="goal_card">
                                <div className="goal_icon">📱</div>
                                <div className="goal_content">
                                    <h4>Increase Sales</h4>
                                    <p className="goal_metric">+ 14% growth</p>
                                </div>
                            </div>

                            <div className="goal_card">
                                <div className="goal_icon">📦</div>
                                <div className="goal_content">
                                    <h4>Clear Inventory</h4>
                                    <p className="goal_metric">+ 12% reduction</p>
                                </div>
                            </div>

                            <div className="goal_card">
                                <div className="goal_icon">🏷️</div>
                                <div className="goal_content">
                                    <h4>Promote New Collection</h4>
                                    <p className="goal_metric">+ 4.3k sold warmed</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="campaign_settings_section">
                        <h3 className="section_title">Add Campaign </h3>

                        <div className="form">
                            <div className="gap_m w_100">
                                {/* Campaign Name */}
                                <div className="control_group w_100">
                                    <label htmlFor="ai-campaign-name">Campaign Name</label>
                                    <TextField
                                        placeholder="New Campaign Name"
                                        fullWidth
                                        value={campaignName}
                                        onChange={(e) => setCampaignName(e.target.value)}
                                        inputProps={{ id: "ai-campaign-name" }}
                                    />
                                </div>

                                {/* Campaign For */}
                                <div className="control_group w_50">
                                    <label htmlFor="ai-campaign-for">Campaign For</label>
                                    <FormControl fullWidth>
                                        <Select
                                            displayEmpty
                                            value={campaignFor}
                                            onChange={(e) => {
                                                setCampaignFor(e.target.value);
                                                setSelectedItems([]);
                                                setSelectedVendors([]);
                                            }}
                                            inputProps={{ id: "ai-campaign-for" }}
                                        >
                                            <MenuItem value="" disabled>
                                                Select for which campaign applies
                                            </MenuItem>
                                            <MenuItem value="Category">Category</MenuItem>
                                            <MenuItem value="Vendor">Vendor</MenuItem>
                                            <MenuItem value="Segment">Segment</MenuItem>
                                            <MenuItem value="Subscription">Subscription</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>

                                {/* Conditional Fields based on Campaign For */}
                                {campaignFor === "Vendor" && (
                                    <>
                                        <div className="control_group w_50">
                                            <label htmlFor="ai-select-vendors">Select Vendors</label>
                                            <FormControl fullWidth>
                                                <Select
                                                    multiple
                                                    displayEmpty
                                                    value={selectedVendors}
                                                    onChange={(e) => {
                                                        setSelectedVendors(e.target.value as string[]);
                                                    }}
                                                    input={<OutlinedInput />}
                                                    renderValue={(selected) =>
                                                        selected.length === 0
                                                            ? "Select Vendor(s)"
                                                            : selected.join(", ")
                                                    }
                                                    inputProps={{ id: "ai-select-vendors" }}
                                                >
                                                    {vendorList.map((name) => (
                                                        <MenuItem key={name} value={name}>
                                                            <Checkbox checked={selectedVendors.indexOf(name) > -1} />
                                                            <ListItemText primary={name} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>

                                        <div className="control_group w_50">
                                            <label htmlFor="ai-marketing-funding">Marketing Funding</label>
                                            <FormControl fullWidth>
                                                <Select
                                                    displayEmpty
                                                    value={marketingFunding}
                                                    onChange={(e) => setMarketingFunding(e.target.value)}
                                                    inputProps={{ id: "ai-marketing-funding" }}
                                                >
                                                    <MenuItem value="" disabled>
                                                        Select Funding Type
                                                    </MenuItem>
                                                    <MenuItem value="Platform-funded">Platform-funded</MenuItem>
                                                    <MenuItem value="Vendor-funded">Vendor-funded</MenuItem>
                                                    <MenuItem value="Hybrid">Hybrid</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </>
                                )}

                                {(campaignFor === "Category" || campaignFor === "Segment" || campaignFor === "Subscription") && (
                                    <div className="control_group w_100">
                                        <label htmlFor="ai-campaign-items">Select {campaignFor}</label>
                                        <FormControl fullWidth>
                                            <Select
                                                multiple
                                                displayEmpty
                                                value={selectedItems}
                                                onChange={(e) =>
                                                    setSelectedItems(e.target.value as string[])
                                                }
                                                input={<OutlinedInput />}
                                                renderValue={(selected) =>
                                                    selected.length === 0
                                                        ? `Select ${campaignFor}(s)`
                                                        : selected.join(", ")
                                                }
                                                inputProps={{ id: "ai-campaign-items" }}
                                            >
                                                {(campaignFor === "Category" ? categories :
                                                    campaignFor === "Segment" ? segments :
                                                        subscriptions).map((name) => (
                                                            <MenuItem key={name} value={name}>
                                                                <Checkbox checked={selectedItems.indexOf(name) > -1} />
                                                                <ListItemText primary={name} />
                                                            </MenuItem>
                                                        ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                )}
                                <div className="control_group w_50">
                                    <label>Campaign Duration</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    label="Start Date"
                                                    value={startDate}
                                                    onChange={(newValue) => setStartDate(newValue)}
                                                    slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    label="End Date"
                                                    value={endDate}
                                                    onChange={(newValue) => setEndDate(newValue)}
                                                    slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </LocalizationProvider>
                                </div>

                                {/* Products Dropdown */}
                                <div className="control_group w_100">
                                    <label htmlFor="ai-select-products">Select Products</label>
                                    <FormControl fullWidth>
                                        <Select
                                            multiple
                                            displayEmpty
                                            value={selectedProducts}
                                            onChange={(e) =>
                                                setSelectedProducts(e.target.value as string[])
                                            }
                                            input={<OutlinedInput />}
                                            renderValue={(selected) =>
                                                selected.length === 0
                                                    ? "Select Products on which discount will apply"
                                                    : selected.join(", ")
                                            }
                                            inputProps={{ id: "ai-select-products" }}
                                        >
                                            {products.map((name) => (
                                                <MenuItem key={name} value={name}>
                                                    <Checkbox checked={selectedProducts.indexOf(name) > -1} />
                                                    <ListItemText primary={name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>

                                {/* Duration */}
                                <div className="control_group w_100">
                                    <label>Target Audience</label>
                                    <RadioGroup
                                        row
                                        value={duration}
                                        onChange={(e) => setDuration(e.target.value)}
                                    >
                                        <FormControlLabel
                                            value="All Users"
                                            control={<Radio />}
                                            label="All Users"
                                        />
                                        <FormControlLabel
                                            value="New Users"
                                            control={<Radio />}
                                            label="New Users"
                                        />
                                        <FormControlLabel
                                            value="Segment"
                                            control={<Radio />}
                                            label="Segment"
                                        />
                                    </RadioGroup>
                                </div>

                            </div>

                            {/* Create Campaign Button */}
                            <div className="btn_flex mt_20">
                                <Button className="btn btn_primary" onClick={handleSave}>
                                    Generate Campaign
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Recommendations</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* AI Sales Recommendation Graph */}
                        <div className="ai_sales_forecast">
                            <div className="forecast_header">
                                <h4>📈 AI Sales Forecast</h4>
                                <p className="forecast_subtitle">Predicted sales increase with recommended campaign</p>
                            </div>

                            <div className="forecast_stats">
                                <div className="stat_item">
                                    <span className="stat_label">Current Monthly</span>
                                    <span className="stat_value">AED 125K</span>
                                </div>
                                <div className="stat_item forecast_highlight">
                                    <span className="stat_label">Projected Monthly</span>
                                    <span className="stat_value">AED 198K</span>
                                    <span className="stat_change">+58% ↑</span>
                                </div>
                            </div>

                            <div className="forecast_chart">
                                <svg width="100%" height="200" viewBox="0 0 400 200" preserveAspectRatio="none">
                                    {/* Grid lines */}
                                    <line x1="0" y1="50" x2="400" y2="50" stroke="#f0f0f0" strokeWidth="1" />
                                    <line x1="0" y1="100" x2="400" y2="100" stroke="#f0f0f0" strokeWidth="1" />
                                    <line x1="0" y1="150" x2="400" y2="150" stroke="#f0f0f0" strokeWidth="1" />

                                    {/* Baseline (without campaign) - dashed line */}
                                    <path
                                        d="M 0,120 L 100,115 L 200,110 L 300,108 L 400,105"
                                        fill="none"
                                        stroke="#94a3b8"
                                        strokeWidth="2"
                                        strokeDasharray="5,5"
                                    />

                                    {/* Projected sales (with AI campaign) - gradient area */}
                                    <defs>
                                        <linearGradient id="salesGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                            <stop offset="0%" stopColor="#f59e0b" stopOpacity="0.3" />
                                            <stop offset="100%" stopColor="#f59e0b" stopOpacity="0.05" />
                                        </linearGradient>
                                    </defs>

                                    {/* Area under projected line */}
                                    <path
                                        d="M 0,120 L 100,100 L 200,70 L 300,40 L 400,20 L 400,200 L 0,200 Z"
                                        fill="url(#salesGradient)"
                                    />

                                    {/* Projected line */}
                                    <path
                                        d="M 0,120 L 100,100 L 200,70 L 300,40 L 400,20"
                                        fill="none"
                                        stroke="#f59e0b"
                                        strokeWidth="3"
                                    />

                                    {/* Data points */}
                                    <circle cx="0" cy="120" r="4" fill="#f59e0b" />
                                    <circle cx="100" cy="100" r="4" fill="#f59e0b" />
                                    <circle cx="200" cy="70" r="4" fill="#f59e0b" />
                                    <circle cx="300" cy="40" r="4" fill="#f59e0b" />
                                    <circle cx="400" cy="20" r="4" fill="#f59e0b" />
                                </svg>

                                <div className="chart_labels">
                                    <span>Week 1</span>
                                    <span>Week 2</span>
                                    <span>Week 3</span>
                                    <span>Week 4</span>
                                    <span>Week 5</span>
                                </div>
                            </div>

                            <div className="forecast_legend">
                                <div className="legend_item">
                                    <span className="legend_line baseline"></span>
                                    <span>Baseline (No Campaign)</span>
                                </div>
                                <div className="legend_item">
                                    <span className="legend_line projected"></span>
                                    <span>With AI Campaign</span>
                                </div>
                            </div>

                            <div className="forecast_insight">
                                <span className="insight_icon">💡</span>
                                <p><strong>AI Insight:</strong> Campaign is predicted to generate <strong>AED 73K additional revenue</strong> over 5 weeks based on historical data and market trends.</p>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default AiCampaignBuilder;
